"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const resetPasswordTranslations = {
    resetPassword: "Reset Password",
    resetPasswordMessage: "Enter your password, confirm password and 6-digit code sent on ",
    resendCodeMessage: "6-digit code resent successfully!",
    enterCode: "Enter 6-digit code",
    confirmPassword: "Confirm Password",
    resendCode: "Resend code",
    newPasswordError: "Please enter new password",
    confirmPasswordError: "Please enter confirm new password",
    codeError: "Please enter 6-digit code",
    passwordCriteriaError: "Password does not meet the criteria",
    confirmPasswordMatchError: "New password and confirm password did not match",
    invalidCodeError: "Please enter valid code",
    resetPasswordSuccess: "Password changed successfully!",
    resendCodeCountdownMessage: "Resend 6-digit code in",
    resendCodeCountdownTime: "{{ remainingSeconds }} second(s)",
    passwordCriteria: {
        start: "Password must contain at least",
        end: "character, no space, minimum 8 and maximum 25 characters",
        uppercase: "1 uppercase",
        lowercase: "1 lowercase",
        number: "1 number",
        special: "1 special",
    },
    passwordCriteriaChecklist: {
        heading: "Password must contain:",
        uppercase: "At least 1 uppercase letter",
        lowercase: "At least 1 lowercase letter",
        number: "At least 1 number",
        special: "At least 1 special character",
        length: "Minimum 8 and maximum 25 characters",
        noSpaces: "No spaces",
    },
};
exports.default = resetPasswordTranslations;
